import enviro from 'enviro';
import Raven from 'raven-js';
import { getFullUrl } from 'hubspot-url-utils';
import { parse } from 'hub-http/helpers/params';
import { FMMessageType } from '../constants';
const ENV_KEY = 'file_manager';
export const isDebug = () => enviro.debug(ENV_KEY);
export const isDeployed = () => enviro.deployed(ENV_KEY);
export const isLocal = () => enviro.getShort(ENV_KEY) === 'local';
export const logDebug = (...args) => {
  if (isDebug()) {
    console.log('[file-manager]', ...args);
  }
};
let queryParams;
export const parseQueryObject = (location = window.location) => {
  if (queryParams) {
    return Object.assign({}, queryParams);
  }
  queryParams = parse(location.search.substring(1));
  return queryParams;
};
export const isFileManagerMessage = e => {
  if (isDeployed()) {
    if (e.origin !== window.location.origin && /* eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils */
    e.origin !== 'https://local.hubspotqa.com') {
      return false;
    }
  }
  return typeof e.data === 'object' && e.data.messageType === FMMessageType;
};
export function isIframed() {
  return window.parent !== window;
}
export function getApiHostForEnvironment() {
  let apiUrl = getFullUrl('app-api');
  if (enviro.getShort('file_manager_api') === 'local') {
    apiUrl = getFullUrl('local', {
      envOverride: 'qa'
    });
  }
  return apiUrl.replace('https://', '');
}
export const getCurrentApp = () => {
  // @ts-expect-error hubspot.bender lacks types
  if (!(window.hubspot && window.hubspot.bender)) {
    return null;
  }
  return window.hubspot.bender.currentProject;
};
export function getCurrentAppVersion() {
  return window.hubspot &&
  // @ts-expect-error No hubspot type in global window yet
  window.hubspot.bender &&
  // @ts-expect-error No hubspot type in global window yet
  window.hubspot.bender.currentProjectVersion;
}
export function appendStaticAppInfo(url) {
  const staticAppName = getCurrentApp();
  const staticAppVersion = getCurrentAppVersion();
  if (staticAppName) {
    url = `${url}&hs_static_app=${staticAppName}`;
    if (staticAppVersion && staticAppVersion !== 'static') {
      url = `${url}&hs_static_app_version=${staticAppVersion}`;
    }
  }
  return url;
}

// firing a global FileManagerLib:Drawer:open event allows apps work around a Chrome bug
// that prevents drag and drop events to the file manager drawer if it is on top of an iframe.
// More info in https://git.hubteam.com/HubSpot/FileManagerUI/pull/1272
export function fireEvent(type) {
  document.dispatchEvent(new CustomEvent(type));
}
export function createWrapperEl() {
  const wrapperEl = document.createElement('div');
  wrapperEl.id = 'file_manager_wrapper';
  setStyles(wrapperEl, {
    display: 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1112,
    'pointer-events': 'none'
  });
  return wrapperEl;
}
export function setStyles(el, styleObj = {}) {
  if (el instanceof HTMLElement) {
    Object.assign(el.style, styleObj);
  }
}
export function truthyObject(obj) {
  obj = Object.assign({}, obj);
  Object.keys(obj).forEach(key => {
    if (obj[key] === undefined || obj[key] === null) {
      delete obj[key];
    }
  });
  return obj;
}
export function trackBreadcrumb(message, data) {
  Raven.captureBreadcrumb({
    message: `[file-manager] ${message}`,
    data
  });
}
let id = 1;
export function uniqueId(prefix = '') {
  return `${prefix}${id++}`;
}
export async function localUrlToFileUrl(url) {
  const res = await fetch(url);
  const blob = await res.blob();
  const filename = url.split('/').pop() || 'file';
  return new File([blob], filename, {
    type: blob.type
  });
}